<template lang="pug">
div.form-field.form-group
    // input element
    div(v-if="isInputTag")
        label {{ setting.display_name }}
        input.form-control.w-lg(
            :placeholder="setting.placeholder",
            v-model="value",
            :type="setting.input_type",
        )
    
    // textarea
    div(v-if="setting.input_type === 'textarea'")
        label {{ setting.display_name }}
        textarea.form-control.w-lg(
            :type="setting.input_type",
            v-model="value",
            rows="3",
        )

    // switch
    p(v-if="setting.input_type === 'switch'")
        label.md-switch
            input.has-value(
                type="checkbox",
                :name="setting.name",
                v-model="value"
            )
            i.indigo
            | {{ setting.display_name }}

    // radio
    div(v-if="setting.input_type === 'radio'")
        p {{ setting.display_name }}
        label.md-check.m-r-md(
            :name="setting.name",
            v-for="(option, index) in setting.options",
            :key="index"
        )
            input.has-value(
                type="radio",
                :value="option.value",
                :name="setting.name",
                v-model="value"
            )
            i.indigo
            | {{ option.name }}


    // checkbox
    div(v-if="setting.input_type === 'checkbox'")
        p {{ setting.display_name }}
        label.md-check.m-r-md(
            :name="setting.name",
            v-for="(option, index) in setting.options",
            :key="index"
        )
            input.has-value(type="checkbox", :value="option.value", v-model="value")
            i.indigo
            | {{ option.name }}

    // datepicker
    div.w-lg(v-if="setting.input_type === 'date'")
        p {{ setting.display_name }}
        datepicker-input(
            v-model="value"
        )

    // datetime picker
    div(v-if="setting.input_type === 'datetime'")
        p {{ setting.display_name }}
        calendar(:value="null", input-class="form-control", class-name="w-lg", v-model="value")

    // time picker
    div.w-lg(v-if="setting.input_type === 'time'")
        p {{ setting.display_name }}
        timepicker-input(v-model="value")

    p.m-t-xs(v-if="hasInstruction")
        small {{ setting.instructions }}

    span.form-error-msg.text-danger(
        v-if="validator.errors.has(`central_settings.${setting.name}`)"
    ) {{ validator.errors.first(`central_settings.${setting.name}`) }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DatepickerInput from '@js/components/datepicker/datepicker.vue';
import timepickerInput from '@js/components/timepicker/timepicker.vue';
import calendar from '@js/components/Calendar.vue';

export default {
    inject: ['$validator'],

    components: {
        DatepickerInput,
        timepickerInput,
        calendar,
    },

    props: {
        setting: {
            type: Object,
            required: true,
        },

        validator: {
            type: Object,
            required: true,
        },
    },

    computed: {
        value: {
            get() {
                return this.setting.value;
            },
            set(newVal) {
                const params = {
                    name: this.setting.name,
                    value: this.processValue(newVal),
                };

                this.setSettingValue(params);
            },
        },

        ...mapGetters('centralSettings', []),

        hasInstruction() {
            return (
                this.setting.instructions !== null &&
                this.setting.instructions.trim() !== ''
            );
        },

        isInputTag() {
            const inputElems = ['text', 'email', 'tel', 'number'];
            return inputElems.indexOf(this.setting.input_type) >= 0;
        },
    },

    methods: {
        ...mapActions('centralSettings', ['setSettingValue']),

        processValue(value) {
            if (this.setting.input_type == 'time') {
                if (value instanceof window.moment) {
                    return value.format('HH:mm');
                }
            }

            if (this.setting.input_type == 'datetime') {
                if (value instanceof window.moment) {
                    return value.format('YYYY-MM-DD HH:mm');
                }
            }

            if (this.setting.input_type == 'date') {
                if (value instanceof window.moment) {
                    return value.format('YYYY-MM-DD');
                }
            }

            return value;
        },
    },
};
</script>

<style lang="scss" scoped>
.form-field {
    &:last-child {
        margin-bottom: 0;

        p:last-child {
            margin-bottom: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/central-settings/central-setting-form-input.vue